<!-- Единый фирменный логотип приложения для основной и публичной оболочки. -->
<template>
  <svg
    class="app-logo"
    :width="width"
    :height="height"
    viewBox="0 0 1232 1226"
    fill="currentColor"
    role="img"
    :aria-label="label"
  >
    <g>
      <polygon
        points="1112.67,772.59 1111.5,1136.77 89.95,1136.77 89.95,115.23 1111.5,115.23 1110.33,477.87 1145.55,477.87 1146.73,80 54.73,80 54.73,1172 1146.73,1172 1147.9,772.59"
      />
      <g>
        <path
          d="M405.53,444v52.21h-65.36v211.73h-62.65V496.21h-65.74V444H405.53z"
        />
        <path
          d="M428.08,773.36l-1.17-233.39h52.98v25.62c9.79-19.5,26.94-29.25,51.43-29.25c21.14,0,38.45,7.59,51.92,22.76c13.47,15.18,20.21,37.25,20.21,66.21c0,30.81-6.8,54.04-20.4,69.67c-13.6,15.64-31.29,23.45-53.08,23.45c-22.04,0-37.77-7.67-47.18-23.02l1.17,77.95H428.08z M482.79,638.29c0,12.35,0.84,20.89,2.51,25.62c1.67,4.73,5.22,8.97,10.64,12.72c5.41,3.75,11.28,5.63,17.59,5.63c7.86,0,14.89-3.61,21.08-10.82c6.19-7.21,9.28-23.11,9.28-47.69c0-34.5-10.18-51.76-30.55-51.76c-7.73,0-14.76,3.06-21.08,9.17c-6.32,6.12-9.47,16.5-9.47,31.16V638.29z"
        />
        <path
          d="M804.31,714.79h-55.88c-1.81-6.92-2.71-16.04-2.71-27.35c-9.78,12.46-19.53,20.74-29.25,24.84c-9.72,4.09-20.75,6.14-33.11,6.14c-18.28,0-33.05-4.44-44.31-13.33c-11.26-8.89-16.89-20.83-16.89-35.83c0-10.96,3.28-21.06,9.85-30.29c6.56-9.23,17.12-16.47,31.66-21.72c14.54-5.25,41.06-9.14,79.54-11.68v-10.04c0-16.96-9.45-25.45-28.34-25.45c-20.18,0-31.42,8.48-33.73,25.45l-53.17-4.5c3.48-19.85,13.98-33.93,31.52-42.24c17.53-8.31,37.38-12.46,59.55-12.46c13.28,0,25.78,1.38,37.51,4.15c11.73,2.77,20.88,6.92,27.46,12.46c6.57,5.54,11.02,11.4,13.34,17.57c2.32,6.17,3.48,16.94,3.48,32.28v79.28C800.83,697.31,801.99,708.22,804.31,714.79z M743.21,631.02c-40.22,3.58-60.33,14.48-60.33,32.72c0,6.12,2.12,11.4,6.36,15.84c4.24,4.44,10.28,6.66,18.12,6.66c10.15,0,18.66-3.78,25.54-11.34c6.87-7.56,10.31-16.88,10.31-27.95V631.02z"
        />
        <path
          d="M949.14,616.29l85.44,98.5h-60.49l-56.57-67.94l-18.1,17.74v50.2h-57.62V540.01h57.62v43.61c0,7.05-0.26,17.32-0.77,30.83c4.51-5.89,9.99-11.89,16.44-18.01l59.01-56.47h53.32L949.14,616.29z"
        />
        <path
          d="M1124.35,534.23c30.14,0,53.65,8.83,70.54,26.48c16.89,17.65,25.34,39.75,25.34,66.28c0,26.19-8.77,48.02-26.32,65.49c-17.55,17.48-40.87,26.22-69.95,26.22c-28.18,0-50.72-8.65-67.61-25.95c-16.89-17.3-25.34-39.51-25.34-66.63c0-18.82,3.81-34.81,11.45-47.96c7.63-13.15,18.1-23.76,31.41-31.83S1104,534.23,1124.35,534.23z M1125.92,568.42c-11.07,0-19.4,3.83-25,11.49c-5.6,7.66-8.4,22.88-8.4,45.68c0,20.93,2.67,35.95,8.01,45.07c5.34,9.12,13.67,13.68,25,13.68c9.9,0,17.9-3.89,24.02-11.66c6.12-7.77,9.18-22.59,9.18-44.45c0-23.26-2.7-39.04-8.1-47.34C1145.22,572.58,1136.99,568.42,1125.92,568.42z"
        />
        <rect x="191.11" y="443.41" width="236.01" height="52.84" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "AppLogo",
  props: {
    width: { type: [Number, String], default: 60 },
    height: { type: [Number, String], default: 60 },
    label: { type: String, default: "Трако" },
  },
};
</script>

<style scoped>
.app-logo {
  display: block;
  flex: none;
}
</style>
